import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../Shared/ErrorPopUp'
import { AsyncWarehouseSelect } from '../Shared/AsyncWarehouseSelect'
import { AsyncCategorySelect } from '../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../Shared/AsyncBrandSelect'
import ProductOperationsTable from '../Shared/ProductOperationsTable'
import unitTypes from '../../_constants/unitTypes'


export default ({ touched, errors, setFieldValue, values, handleBlur, categoryType, unitProductOperationType }) => (
  <div className="row display-flex" style={{ minHeight: 'calc(100vh - 220px)' }}>
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <div className="row">
        <div className="form-inline">

          <div className="col-md-3">
            <label>نام انبار</label>
            <AsyncWarehouseSelect
              // categoryType={categoryType}
              defaultValue={values.unitId}
              onChange={(val, unitType_) => {

                if (unitType_ !== undefined) {

                  var unitType = (unitTypes.filter(el => el.value === unitType_)[0]);

                  if (unitType !== undefined) {

                    categoryType = unitType.categoryType;

                    setFieldValue('categoryType', categoryType)

                  }

                }
                setFieldValue('dto', undefined)
                setFieldValue('unitId', val)
              }}

              className={getIn(touched, "unitId") ? getIn(errors, "unitId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="unitId" />
          </div>

          <div className="col-md-3">
            <label>دسته بندی</label>
            <AsyncCategorySelect
              clearable
              categoryType={values.categoryType}
              defaultValue={values.categoryId}
              onChange={(val) => {
                // console.log(val);
                setFieldValue('dto', undefined)
                setFieldValue('categoryId', val)
              }}

              className={getIn(touched, "categoryId") ? getIn(errors, "categoryId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="categoryId" />
          </div>

          <div className="col-md-3">
            <label>برند</label>
            <AsyncBrandSelect
              clearable
              brandType={values.categoryType === -1 ? -1 : values.categoryType === 0 ? 0 : 1}
              defaultValue={values.brandId}
              onChange={(val) => {
                // console.log(val);
                setFieldValue('dto', undefined)
                setFieldValue('brandId', val)
              }}

              className={getIn(touched, "brandId") ? getIn(errors, "brandId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="brandId" />
          </div>

          <div className="col-md-3">
            <label>&nbsp;</label>
            <a className="btn btn-primary btn-block" style={{ borderRadius: 25, margin: 0, maxHeight: 36 }}
              onClick={() => {
                let dto = {}
                values.unitId && (dto["unitId"] = values.unitId)
                values.categoryId && (dto["categoryId"] = values.categoryId)
                values.brandId && (dto["brandId"] = values.brandId)
                setFieldValue('dto', dto)
              }}
            >نمایش کالاها</a>
          </div>


          <div className="col-md-12 col-sm-12">
            <hr />
            <fieldset className="fieldset">
              <ProductOperationsTable
                dto={values.dto}
                // brandId={values.brandId}
                // categoryId={values.categoryId}
                // unitId={values.unitId}
                unitProductOperationType={unitProductOperationType}
                // defaultValue={values.productId}
                onChange={(val) => {
                  setFieldValue('list', val)
                }}

                className={getIn(touched, "list") ? getIn(errors, "list") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
              />
            </fieldset>
            <ErrorMessage component={ErrorPopUp} name="list" />
          </div>


        </div>
      </div>

    </div>

  </div>
);